import { render, staticRenderFns } from "./CoPaceCommunity.vue?vue&type=template&id=0b9bb472&scoped=true&"
import script from "./CoPaceCommunity.vue?vue&type=script&setup=true&lang=js&"
export * from "./CoPaceCommunity.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9bb472",
  null
  
)

export default component.exports